<template>
	<div v-if="allData[currentHelpFieldName] && Array.isArray(allData[currentHelpFieldName].data)">
		<table>
			<tbody>
			<template v-for="(info, index) in allData[currentHelpFieldName].data" :key="index">
				<tr class="p-p-2">
					<td class="p-text-bold">
						{{ info.version }}:
					</td>
					<td>
						{{ info.description }}
					</td>
				</tr>
			</template>
			</tbody>
		</table>
	</div>
	<div v-else>{{ allData[currentHelpFieldName].data }}</div>
	<b><a class="urlText" :href="'https://docs.squeeze.one/books/squeeze-2-admin-handbuch/page/stapelklasseneigenschaften-ocr-texterkennung'" target="_blank">
		({{ $t('Squeeze.General.LinkToDocumentation') }})
	</a></b>
</template>

<script lang="ts">
import {defineComponent, reactive} from 'vue';
import {useI18n} from "vue-i18n";

interface OcrSettingData {
	[key: string]: {
		data: any;
	};
}

export default defineComponent({
	name: "OverlayHelpDialog",
	components: {},
	props: {
		currentHelpFieldName: {
			type: String,
			required: true,
		},
	},
	setup() {
		const {t} = useI18n();

		/** Current documentation of all data */
		const allData = reactive<OcrSettingData>({
			"OCRForce": {
				data: t('Squeeze.BatchClasses.OCRForeHelpText'),
			},
			"OCRLanguage": {
				data: t('Squeeze.BatchClasses.OCRLanguageHelpText'),
			},
			"OCRPageLimit": {
				data: t('Squeeze.BatchClasses.OCRPageLimitHelpText'),
			},
			"OCRTesseractVersion": {
				data: t('Squeeze.BatchClasses.OCRTesseractVersionHelpText'),
			},
			"PDFA-Conversion": {
				data: t('Squeeze.BatchClasses.PDFAConversionHelpText'),
			},
			"PDFProcessor": {
				data: t('Squeeze.BatchClasses.PDFProcessorHelpText'),
			},
			"PSM-Mode": {
				data: [
					{
						version: "3",
						description: t('Squeeze.BatchClasses.PSMModeVersionThreeHelpText'),
					},
					{
						version: "4",
						description: t('Squeeze.BatchClasses.PSMModeVersionFourHelpText'),
					},
					{
						version: "6",
						description: t('Squeeze.BatchClasses.PSMModeVersionSixHelpText'),
					},
					{
						version: "11",
						description: t('Squeeze.BatchClasses.PSMModeVersionElevenHelpText'),
					},
				],
			},
		});

		return {
			t,
			allData,
		}
	},
})
</script>

<style scoped>

.urlText {
	text-decoration: none;
	color: var(--text-color);
}

.urlText:hover {
	color: var(--dex-primary-color);
}

</style>
